/**
 * Feedback domain constants matching Flutter app configuration
 */

/**
 * Max draft screenshots, parity with Flutter's `length >= 3` guard (:127-129).
 * Exported so the page's add-tap guard references the same single source of
 * truth the hook enforces, rather than re-inlining `3`.
 */
export const MAX_FEEDBACK_SCREENSHOTS = 3;
